//   request statuses
export const IDLE = 'idle';
export const LOADING = 'loading';
export const FULFILLED = 'fulfilled';
